import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import ToggleButton from 'components/atoms/ToggleButton';
import { bindActionCreators, Dispatch } from 'redux';
import { offsetByVisit, updateTransit } from 'services/transits';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import { OffsetType, OpenModal, PortType, RootState, TransitType, VesselCategoryType } from 'types';
import { MainControlsInterface } from 'types/functions';
import { ActionsType } from 'types/system';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';

interface EditTransitModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;
    vesselCategories: VesselCategoryType[];
    id?: string;
    data: any;
    actions: ActionsType | undefined;
    mainControls: MainControlsInterface;
    port: PortType;
    showMessageAction: ShowMessageAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    openModelFunction: OpenModal;
    setLayoutAction: SetLayoutAction;
}

interface EditTransitModelState {
    transit: TransitType | null;
    data: any;
}

class EditTransitModel extends Component<EditTransitModelProps, EditTransitModelState> {
    constructor(props: EditTransitModelProps) {
        super(props);
        this.state = {
            transit: null,
            data: {},
        };
    }

    componentDidMount = () => {
        //@ts-ignore
        const { transit, transitData } = this.props.mainControls.getTransit(this.props.data.id);

        if (!transit) {
            window?.log('ERROR : Invalid transit data', 'color: red');
            return;
        }

        console.log(transit, transitData);
        //@ts-ignore
        offsetByVisit(this.props.port.id, transit.visit_id)
            .then((res) => {
                let offsets: OffsetType[] =  res.items

                const sourceTransitOffsets = offsets.find((item) => {
                    return item.type == 'AIS CLASS A' || item.type == 'AIS CLASS B';
                });
                const manualTransitOffsets = offsets.find((item) => {
                    return item.type == 'manual';
                });
                const corectedTransitOffsets = offsets.find((item) => {
                    return item.type == 'calculated';
                });

                const offset = manualTransitOffsets ?? corectedTransitOffsets ?? sourceTransitOffsets;
                if (!sourceTransitOffsets) {
                    this.props.showMessageAction({
                        messageType: 'ERROR',
                        message: translate('No AIS offsets found for this visit'),
                    });
                }
                this.setState(
                    {
                        transit,
                        data: {
                            delete: false,
                            analysis: false,
                            updateMovment: false,
                            metOceant: false,
                            vessel: transit.vessel,
                            visit_id: transit.visit_id,
                            corectedTransitOffsets: offset
                                ? offset
                                : {
                                      stern_m: transit.vessel.loa_m / 2,
                                      port_m: transit.vessel.beam_m / 2,
                                      bow_m: transit.vessel.loa_m / 2,
                                      stbd_m: transit.vessel.beam_m / 2,
                                      heading_correction: 0,
                                      forward_correction: '0.00',
                                      heading_with: 0,
                                      heading: 'no heading data',
                                      lateral_correction: 0,
                                      lateral_with: 0,
                                      lateral: 'no lateral data',
                                  },
                            updatedTransitOffsets: offset
                                ? { ...offset }
                                : {
                                      stern_m: transit.vessel.loa_m / 2,
                                      port_m: transit.vessel.beam_m / 2,
                                      bow_m: transit.vessel.loa_m / 2,
                                      stbd_m: transit.vessel.beam_m / 2,
                                      forward_correction: 0,
                                      heading_correction: 0,
                                      heading_with: 0,
                                      heading: 'no heading data',
                                      lateral_correction: 0,
                                      lateral_with: 0,
                                      lateral: 'no lateral data',
                                  },
                            sourceTransitOffsets: sourceTransitOffsets
                                ? sourceTransitOffsets
                                : {
                                      stern_m: transit.vessel.loa_m / 2,
                                      port_m: transit.vessel.beam_m / 2,
                                      bow_m: transit.vessel.loa_m / 2,
                                      stbd_m: transit.vessel.beam_m / 2,
                                      heading_correction: 0,
                                      forward_correction: 0,
                                      heading_with: 0,
                                      heading: 'no heading data',
                                      lateral_correction: 0,
                                      lateral_with: 0,
                                      lateral: 'no lateral data',
                                  },

                            forReview:
                                transit.transit_tags.find((item) => {
                                    return item.tag.tag == 'For review';
                                }) != undefined,
                        },
                    },
                    () => {
                        this.updateForward(this.state.data.corectedTransitOffsets.forward_correction);
                    }
                );
            })
            .catch((errors) => {
                this.props.setErrorHandlerAction(errors);
            });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();

        this.props.setSystemLoadingAction(true);
        this.props.setLayoutAction([
            {
                action: 'DEFAULT',
                data: {
                    updateTransit: this.state.transit?.id,
                },
            },
        ]);
        //@ts-ignore
        updateTransit(this.props.port.id, this.state.transit.id, {
            ...this.state.data,
            offset: this.state.data.updatedTransitOffsets,
            updateOffset: checkDifferent(
                this.state.data.updatedTransitOffsets,
                this.state.data.colclatedTransitOffsets
            ),
        })
            .then(() => {
                this.props.mainControls.updateTransits(
                    [this.state.transit?.id || 0],
                    ['updated_at', 'transit_analysis','analysis', 'transit_tags', 'smoothed_positions', 'positions','inspect'],
                    true,
                    this.state.data.updatedTransitOffsets
                );
            })
            .catch((errors) => {
                this.props.showMessageAction({
                    messageType: 'INFO',
                    message: translate(
                        'The update will need up to five minutes to affect your search , please run the search again to see the changes'
                    ),
                });
                this.props.setLayoutAction([
                    {
                        action: 'DEFAULT',
                        data: {
                            updateTransit: null,
                        },
                    },
                ]);
                this.props.setErrorHandlerAction(errors);
            });


        this.props.setSystemLoadingAction(false);
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    drawVesselOutLine = () => {
        const c = document.getElementById('myCanvas');
        //@ts-ignore
        const ctx = c.getContext('2d');
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.moveTo(350, 150);
        ctx.strokeStyle = '#000000'; //red
        ctx.beginPath();

        let drawFactor = 1.5;
        // set drawFactor so diagram appears same size for all vessel lengths. A good length appears to be about 250m
        drawFactor = (drawFactor * 250) / this.state.data.vessel.loa_m;

        //1
        const drawingCenter = {
            x: 350,
            y: 75,
        };

        //2
        const drawingStart = {
            x: drawingCenter.x - (this.state.data.vessel.loa_m / 2) * drawFactor,
            y: drawingCenter.y + (this.state.data.vessel.beam_m / 2) * drawFactor,
        };

        //3
        const vesselSourceCenter = {
            x: drawingStart.x + this.state.data.sourceTransitOffsets.stern_m * drawFactor,
            y: drawingStart.y - this.state.data.sourceTransitOffsets.stbd_m * drawFactor,
        };

        this.drawCircle(vesselSourceCenter, ctx, '#c82124');

        let vesselShape: any = [];

        const customVesselCategorie: VesselCategoryType | undefined = this.props.vesselCategories.find((x) => {
            return x.port_id === this.props.port.id && x.name === this.state.data.vessel?.vessel_category.name;
        });

        if (customVesselCategorie !== undefined) {
            vesselShape = customVesselCategorie.vessel_shape;
        } else if (Array.isArray(this.state.data.vessel?.vessel_category.vessel_shape)) {
            vesselShape = this.state.data.vessel?.vessel_category.vessel_shape;
        }

        this.drawVessel(vesselShape, 0, drawingCenter, vesselSourceCenter, drawFactor, ctx, '#dddddd');

        const headingCorrection = this.state.data.updatedTransitOffsets.heading_correction;

        const vesselCorectedCenter = {
            x: drawingStart.x + this.state.data.sourceTransitOffsets.stern_m * drawFactor,
            y: drawingStart.y - this.state.data.sourceTransitOffsets.stbd_m * drawFactor,
        };
        //4

        const newDrawingStart = this.rotateCW(
            vesselCorectedCenter,
            {
                x:
                    drawingStart.x +
                    (this.state.data.sourceTransitOffsets.stern_m - this.state.data.updatedTransitOffsets.stern_m) *
                        drawFactor,
                y:
                    drawingStart.y -
                    (this.state.data.sourceTransitOffsets.stbd_m - this.state.data.updatedTransitOffsets.stbd_m) *
                        drawFactor,
            },
            headingCorrection
        );

        const vesselCorrectedSourceCenter = this.rotateCW(
            newDrawingStart,
            {
                x: newDrawingStart.x + this.state.data.sourceTransitOffsets.stern_m * drawFactor,
                y: newDrawingStart.y - this.state.data.sourceTransitOffsets.stbd_m * drawFactor,
            },
            headingCorrection
        );

        this.drawCircle(vesselCorrectedSourceCenter, ctx, '#3370d4');

        this.drawVessel(
            vesselShape,
            headingCorrection,
            {
                x:
                    drawingCenter.x +
                    (this.state.data.sourceTransitOffsets.stern_m - this.state.data.updatedTransitOffsets.stern_m) *
                        drawFactor,
                y:
                    drawingCenter.y -
                    (this.state.data.sourceTransitOffsets.stbd_m - this.state.data.updatedTransitOffsets.stbd_m) *
                        drawFactor,
            },
            vesselCorectedCenter,
            drawFactor,
            ctx,
            '#000000'
        );
    };

    drawVessel = (vesselShape, headingCorrection, drawingCenter, vesselCenter, drawFactor, ctx, color) => {
        ctx.beginPath();

        const vesselDefaultShape = [
            [-0.5, 0],
            [-0.5, 0.2258],
            [-0.4243, 0.3859],
            [-0.3673, 0.4668],
            [-0.3157, 0.5],
            [0.3291, 0.5],
            [0.3626, 0.4734],
            [0.3991, 0.4133],
            [0.4587, 0.2508],
            [0.4909, 0.1002],
            [0.5, 0],
            [0.4909, -0.1002],
            [0.4587, -0.2508],
            [0.3991, -0.4133],
            [0.3626, -0.4734],
            [0.3291, -0.5],
            [-0.3157, -0.5],
            [-0.3673, -0.4668],
            [-0.4243, -0.3859],
            [-0.5, -0.2258],
            [-0.5, 0],
        ];

        if (!Array.isArray(vesselShape)) {
            vesselShape = vesselDefaultShape;
        }

        vesselShape.map((coord, i) => {
            const point = this.rotateCW(
                vesselCenter,
                {
                    x: drawingCenter.x + coord[0] * (this.state.data.vessel.loa_m * drawFactor),
                    y: drawingCenter.y - coord[1] * (this.state.data.vessel.beam_m * drawFactor),
                },
                headingCorrection
            );
            if (i != 0) {
                ctx.lineTo(point.x, point.y);
            }
            ctx.moveTo(point.x, point.y);
        });

        ctx.strokeStyle = color;
        ctx.stroke();
        ctx.closePath();
    };

    rotateCW = (center, point, angle) => {
        const radians = (Math.PI / 180) * (angle * -1),
            cos = Math.cos(radians),
            sin = Math.sin(radians),
            nx = cos * (point.x - center.x) + sin * (point.y - center.y) + center.x,
            ny = cos * (point.y - center.y) - sin * (point.x - center.x) + center.y;
        return { x: nx, y: ny };
    };

    drawCircle = (vesselCenter, ctx, color) => {
        ctx.moveTo(vesselCenter.x, vesselCenter.y);
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(vesselCenter.x, vesselCenter.y, 2, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        return vesselCenter;
    };

    toggleForReviewTag = () => {
        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                forReview: !prevState.data.forReview,
            },
        }));
    };

    deleteTransit = () => {
        this.props.openModelFunction(
            'deleteTransitModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('deleteTransitModel');
                },
                onConfirm: () => {
                    this.setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            delete: true,
                        },
                    }));
                },
            }
        );
    };

    reAnalyseTransit = () => {
        this.props.openModelFunction(
            'reAnalyseTransitModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('reAnalyseTransitModel');
                },
                onConfirm: () => {
                    this.setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            analysis: true,
                        },
                    }));
                },
            }
        );
    };

    reFetchMetocean = () => {
        this.props.openModelFunction(
            'reFetchMetoceanModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('reFetchMetoceanModel');
                },
                onConfirm: () => {
                    this.setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            metOceant: true,
                        },
                    }));
                },
            }
        );
    };

    reprocessTransit = () => {
        this.props.openModelFunction(
            'reProcessTransitModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('reProcessTransitModel');
                },
                onConfirm: () => {
                    this.setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            updateMovment: true,
                        },
                    }));
                },
            }
        );
    };

    handleReset = () => {
        this.setState(
            {
                data: {
                    delete: false,
                    analysis: false,
                    updateMovment: false,
                    metOceant: false,
                    vessel: this.state.transit?.vessel,
                    colclatedTransitOffsets: this.state.data.colclatedTransitOffsets,
                    updatedTransitOffsets: { ...this.state.data.colclatedTransitOffsets },
                    sourceTransitOffsets: this.state.data.sourceTransitOffsets,
                    forReview: Boolean(this.state.transit?.transit_tags.find((item) => item.tag.tag === 'For review')),
                },
            },
            this.drawVesselOutLine
        );
    };

    updateOffset = (field, value, updates) => {
        this.setState((prevState) => {
            const { updatedTransitOffsets, sourceTransitOffsets } = prevState.data;

            // Apply the provided updates dynamically
            Object.entries(updates).forEach(([key, updateValue]) => {
                updatedTransitOffsets[key] =
                    typeof updateValue === 'function' ? updateValue(sourceTransitOffsets) : updateValue;
            });

            updatedTransitOffsets[field + '_correction'] = value;
            updatedTransitOffsets[field] = `Manual ${field}`;

            return { data: { ...prevState.data, updatedTransitOffsets } };
        }, this.drawVesselOutLine);
    };

    sanitizeNumber = (value, fallback = 0) => {
        const numericValue = value.toString().replace(/[^0-9.-]/g, '');
        if (numericValue === '' || isNaN(Number(numericValue))) {
            return fallback;
        }
        return parseFloat(numericValue);
    };

    updateHeading = (value) => {
        const numericValue = this.sanitizeNumber(value, 0);
        this.updateOffset('heading', numericValue, {});
    };

    updateLateral = (value) => {
        const numericValue = this.sanitizeNumber(value, 0);
        console.log(numericValue);
        const updates = {
            stbd_m: (source) => parseFloat(source.stbd_m) - numericValue,
            port_m: (source) => parseFloat(source.port_m) + numericValue,
            lateral_correction: numericValue,
        };

        this.updateOffset('lateral', numericValue, updates);
    };

    updateForward = (value) => {
        const numericValue = this.sanitizeNumber(value, 0);
        const formattedValue = numericValue.toFixed(2);

        const updates = {
            bow_m: (source) => (parseFloat(source.bow_m) - numericValue).toFixed(2),
            stern_m: (source) => (parseFloat(source.stern_m) + numericValue).toFixed(2),
            forward_correction: formattedValue,
        };

        this.updateOffset('forward', formattedValue, updates);
    };

    render() {
        return (
            <>
                <Form
                    onSubmit={this.handleFormSubmit}
                    className="bg-white shadow p-4 w-full rounded"
                    style={{ width: '800px' }}
                >
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Edit Transit')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="mt-4 mb-4  relative rounded-md">
                        <div className="pb-4">
                            <div className="py-5">
                                <canvas id="myCanvas" width="700" height="150">
                                    Your browser does not support the HTML canvas tag.
                                </canvas>
                            </div>

                            <table className="text-black w-full text-center ">
                                <tr className="text-black font-bold">
                                    <td colSpan={11} className="text-left">
                                        {translate('AIS source offsets')}
                                    </td>
                                </tr>
                                <tr className="uppercase">
                                    <td>{translate('LOA')}</td>
                                    <td>{translate('BEAM')}</td>
                                    <td>{translate('BOW')}</td>
                                    <td>{translate('STERN')}</td>
                                    <td>{translate('STBD')}</td>
                                    <td>{translate('PORT')}</td>
                                    <td colSpan={5}></td>
                                </tr>
                                <tr>
                                    <td className="py-2">{this.state.data?.vessel?.loa_m}</td>
                                    <td className="py-2">{this.state.data?.vessel?.beam_m}</td>
                                    <td className="py-2">{this.state.data?.sourceTransitOffsets?.bow_m}</td>
                                    <td className="py-2">{this.state.data?.sourceTransitOffsets?.stern_m}</td>
                                    <td className="py-2">{this.state.data?.sourceTransitOffsets?.stbd_m}</td>
                                    <td className="py-2">{this.state.data?.sourceTransitOffsets?.port_m}</td>
                                    <td className="py-2" colSpan={5}></td>
                                </tr>
                                <tr className="text-black font-bold">
                                    <td colSpan={11} className="text-left">
                                        {translate('Corrected offsets')}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="uppercase" rowSpan={2}>
                                        {translate('LOA')}
                                    </td>
                                    <td className="uppercase" rowSpan={2}>
                                        {translate('BEAM')}
                                    </td>
                                    <td className="uppercase" rowSpan={2}>
                                        {translate('BOW')}
                                    </td>
                                    <td className="uppercase" rowSpan={2}>
                                        {translate('STERN')}
                                    </td>
                                    <td className="uppercase" rowSpan={2}>
                                        {translate('STBD')}
                                    </td>
                                    <td className="uppercase" rowSpan={2}>
                                        {translate('PORT')}
                                    </td>
                                    <td className="font-semibold" colSpan={2}>
                                        {translate('Heading correction')}
                                    </td>
                                    <td className="font-semibold" colSpan={2}>
                                        {translate('Lateral correction')}
                                    </td>
                                    <td className="font-semibold">{translate('Forward')}</td>
                                </tr>

                                <tr>
                                    <td>{translate('Auto check')}</td>
                                    <td>{translate('Applied')}</td>
                                    <td>{translate('Auto check')}</td>
                                    <td>{translate('Applied')}</td>
                                    <td>{translate('correction')}</td>
                                </tr>
                                <tr>
                                    <td className="py-2">{this.state.data?.vessel?.loa_m}</td>
                                    <td>{this.state.data?.vessel?.beam_m}</td>
                                    <td className="py-2">{this.state.data?.updatedTransitOffsets?.bow_m}</td>
                                    <td className="py-2">{this.state.data?.updatedTransitOffsets?.stern_m}</td>
                                    <td className="py-2">{this.state.data?.updatedTransitOffsets?.stbd_m}</td>
                                    <td className="py-2">{this.state.data?.updatedTransitOffsets?.port_m}</td>
                                    <td className="py-2">
                                        {this.state.data?.updatedTransitOffsets?.heading_with * -1}
                                    </td>
                                    <td
                                        className="py-2"
                                        onBlur={(e) => {
                                            const textContent = e.currentTarget.textContent;
                                            if (textContent !== null) {
                                                this.updateHeading(textContent);
                                            }
                                        }}
                                        onInput={(e) => {
                                            const el = e.currentTarget;
                                            const text = el.textContent ?? '';

                                            // Keep only numbers, optional minus sign, and one decimal point
                                            const cleaned = text
                                                .replace(/[^0-9.-]/g, '') // remove everything except digits, - and .
                                                .replace(/(?!^)-/g, '') // allow only one minus at start
                                                .replace(/(\..*)\./g, '$1'); // allow only one decimal point

                                            if (text !== cleaned) {
                                                el.textContent = cleaned;
                                                // Move cursor to end
                                                const range = document.createRange();
                                                const sel = window.getSelection();
                                                range.selectNodeContents(el);
                                                range.collapse(false);
                                                sel?.removeAllRanges();
                                                sel?.addRange(range);
                                            }
                                        }}
                                        contentEditable
                                        suppressContentEditableWarning
                                    >
                                        {this.state.data?.updatedTransitOffsets?.heading_correction}
                                    </td>
                                    <td className="py-2">
                                        {this.state.data?.updatedTransitOffsets?.lateral_with * -1}
                                    </td>
                                    <td
                                        className="py-2"
                                        onBlur={(e) => {
                                            const textContent = e.currentTarget.textContent;
                                            if (textContent !== null) {
                                                this.updateLateral(textContent);
                                            }
                                        }}
                                        onInput={(e) => {
                                            const el = e.currentTarget;
                                            const text = el.textContent ?? '';

                                            // Keep only numbers, optional minus sign, and one decimal point
                                            const cleaned = text
                                                .replace(/[^0-9.-]/g, '') // remove everything except digits, - and .
                                                .replace(/(?!^)-/g, '') // allow only one minus at start
                                                .replace(/(\..*)\./g, '$1'); // allow only one decimal point

                                            if (text !== cleaned) {
                                                el.textContent = cleaned;
                                                // Move cursor to end
                                                const range = document.createRange();
                                                const sel = window.getSelection();
                                                range.selectNodeContents(el);
                                                range.collapse(false);
                                                sel?.removeAllRanges();
                                                sel?.addRange(range);
                                            }
                                        }}
                                        contentEditable
                                        suppressContentEditableWarning
                                    >
                                        {this.state.data?.updatedTransitOffsets?.lateral_correction}
                                    </td>
                                    <td
                                        className="py-2"
                                        onBlur={(e) => {
                                            const textContent = e.currentTarget.textContent;
                                            if (textContent !== null) {
                                                this.updateForward(textContent);
                                            }
                                        }}
                                        onInput={(e) => {
                                            const el = e.currentTarget;
                                            const text = el.textContent ?? '';

                                            // Keep only numbers, optional minus sign, and one decimal point
                                            const cleaned = text
                                                .replace(/[^0-9.-]/g, '') // remove everything except digits, - and .
                                                .replace(/(?!^)-/g, '') // allow only one minus at start
                                                .replace(/(\..*)\./g, '$1'); // allow only one decimal point

                                            if (text !== cleaned) {
                                                el.textContent = cleaned;
                                                // Move cursor to end
                                                const range = document.createRange();
                                                const sel = window.getSelection();
                                                range.selectNodeContents(el);
                                                range.collapse(false);
                                                sel?.removeAllRanges();
                                                sel?.addRange(range);
                                            }
                                        }}
                                        contentEditable
                                        suppressContentEditableWarning
                                    >
                                        {this.state.data?.updatedTransitOffsets?.forward_correction}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        {this.state.data?.updatedTransitOffsets?.heading !== 'Manual heading' &&
                                            translate(
                                                this.state.data?.updatedTransitOffsets?.heading?.replace(' heading', '')
                                            )}
                                    </td>
                                    <td className="text-red-500">
                                        {this.state.data?.updatedTransitOffsets?.heading == 'Manual heading' &&
                                            translate(
                                                this.state.data?.updatedTransitOffsets?.heading?.replace(' heading', '')
                                            )}
                                    </td>
                                    <td>
                                        {this.state.data?.updatedTransitOffsets?.lateral !== 'Manual lateral' &&
                                            translate(
                                                this.state.data?.updatedTransitOffsets?.lateral?.replace(' lateral', '')
                                            )}
                                    </td>
                                    <td className="text-red-500">
                                        {this.state.data?.updatedTransitOffsets?.lateral == 'Manual lateral' &&
                                            translate(
                                                this.state.data?.updatedTransitOffsets?.lateral?.replace(' lateral', '')
                                            )}
                                    </td>
                                    <td className="text-red-500">
                                        {this.state.data?.updatedTransitOffsets?.forward_correction != 0
                                            ? translate('Manual')
                                            : null}
                                    </td>
                                </tr>
                            </table>

                            <div className=" hidden text-black font-bold">{translate('AIS source offsets')}</div>
                            <div className="flex hidden justify-between text-center space-x-2">
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('LOA')}
                                    </div>
                                    <div>{this.state.data?.vessel?.loa_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('BEAM')}
                                    </div>
                                    <div>{this.state.data?.vessel?.beam_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('BOW')}{' '}
                                    </div>
                                    <div>{this.state.data?.sourceTransitOffsets?.bow_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle ">
                                        {translate(' STERN')}
                                    </div>
                                    <div>{this.state.data?.sourceTransitOffsets?.stern_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('STBD')}
                                    </div>
                                    <div>{this.state.data?.sourceTransitOffsets?.stbd_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase ">
                                        {translate('PORT')}
                                    </div>
                                    <div>{this.state.data?.sourceTransitOffsets?.port_m}</div>
                                </div>
                            </div>

                            <div className="text-black  hidden font-bold mt-4 ">{translate('Corected offsets')}</div>
                            <div className="flex  hidden justify-between text-center space-x-2">
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('BOW')}{' '}
                                    </div>
                                    <div>{this.state.data?.updatedTransitOffsets?.bow_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('STERN')}
                                    </div>
                                    <div>{this.state.data?.updatedTransitOffsets?.stern_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('STBD')}
                                    </div>
                                    <div>{this.state.data?.updatedTransitOffsets?.stbd_m}</div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle uppercase">
                                        {translate('PORT')}
                                    </div>
                                    <div>{this.state.data?.updatedTransitOffsets?.port_m}</div>
                                </div>

                                <div>
                                    <div className="text-center text-black h-12 align-middle ">
                                        {translate('heading check')}
                                    </div>
                                    <div></div>
                                    <div>
                                        {this.state.data?.updatedTransitOffsets?.heading?.replace(' heading', '')}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle ">
                                        {translate('heading correction')}
                                    </div>
                                    <div
                                        suppressContentEditableWarning
                                        onInput={(e) => {
                                            const el = e.currentTarget;
                                            const text = el.textContent ?? '';

                                            // Keep only numbers, optional minus sign, and one decimal point
                                            const cleaned = text
                                                .replace(/[^0-9.-]/g, '') // remove everything except digits, - and .
                                                .replace(/(?!^)-/g, '') // allow only one minus at start
                                                .replace(/(\..*)\./g, '$1'); // allow only one decimal point

                                            if (text !== cleaned) {
                                                el.textContent = cleaned;
                                                // Move cursor to end
                                                const range = document.createRange();
                                                const sel = window.getSelection();
                                                range.selectNodeContents(el);
                                                range.collapse(false);
                                                sel?.removeAllRanges();
                                                sel?.addRange(range);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const textContent = e.currentTarget.textContent;
                                            if (textContent !== null) {
                                                const value = parseFloat(textContent);
                                                if (!isNaN(value)) {
                                                    this.updateHeading(value);
                                                }
                                            }
                                        }}
                                        contentEditable
                                    ></div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle ">
                                        {translate('lateral check')}
                                    </div>
                                    <div>{this.state.data?.updatedTransitOffsets?.lateral_with}</div>
                                    <div>
                                        {translate(
                                            this.state.data?.updatedTransitOffsets?.lateral?.replace(' lateral', '')
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle ">
                                        {translate('lateral correction')}
                                    </div>
                                    <div
                                        contentEditable
                                        suppressContentEditableWarning
                                        onInput={(e) => {
                                            const el = e.currentTarget;
                                            const text = el.textContent ?? '';

                                            // Keep only numbers, optional minus sign, and one decimal point
                                            const cleaned = text
                                                .replace(/[^0-9.-]/g, '') // remove everything except digits, - and .
                                                .replace(/(?!^)-/g, '') // allow only one minus at start
                                                .replace(/(\..*)\./g, '$1'); // allow only one decimal point

                                            if (text !== cleaned) {
                                                el.textContent = cleaned;
                                                // Move cursor to end
                                                const range = document.createRange();
                                                const sel = window.getSelection();
                                                range.selectNodeContents(el);
                                                range.collapse(false);
                                                sel?.removeAllRanges();
                                                sel?.addRange(range);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const textContent = e.currentTarget.textContent;
                                            if (textContent !== null) {
                                                const value = parseFloat(textContent);
                                                if (!isNaN(value)) {
                                                    this.updateLateral(value);
                                                }
                                            }
                                        }}
                                    >
                                        {this.state.data?.updatedTransitOffsets?.lateral_correction}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-center text-black h-12 align-middle ">
                                        {translate('Forword correction')}
                                    </div>
                                    <div
                                        contentEditable
                                        suppressContentEditableWarning
                                        onInput={(e) => {
                                            const el = e.currentTarget;
                                            const text = el.textContent ?? '';

                                            // Keep only numbers, optional minus sign, and one decimal point
                                            const cleaned = text
                                                .replace(/[^0-9.-]/g, '') // remove everything except digits, - and .
                                                .replace(/(?!^)-/g, '') // allow only one minus at start
                                                .replace(/(\..*)\./g, '$1'); // allow only one decimal point

                                            if (text !== cleaned) {
                                                el.textContent = cleaned;
                                                // Move cursor to end
                                                const range = document.createRange();
                                                const sel = window.getSelection();
                                                range.selectNodeContents(el);
                                                range.collapse(false);
                                                sel?.removeAllRanges();
                                                sel?.addRange(range);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const textContent = e.currentTarget.textContent;
                                            if (textContent !== null) {
                                                const value = parseFloat(textContent);
                                                if (!isNaN(value)) {
                                                    this.updateForward(value);
                                                }
                                            }
                                        }}
                                    >
                                        {this.state.data?.updatedTransitOffsets?.forward_correction}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex py-2 justify-between items-center  ">
                        <div className="flex gap-1">
                            <div>
                                <div className=" font-bold pt-1">
                                    <ToggleButton
                                        onChange={() => {
                                            this.toggleForReviewTag();
                                        }}
                                        value={this.state.data.forReview}
                                    ></ToggleButton>
                                </div>
                                <div> </div>
                            </div>
                            <div>
                                <div className=" font-bold text-sm"> {translate('For review tag')}</div>
                                <div>{translate('removing (or adding) the "for review" tag')}</div>
                            </div>
                        </div>
                    </div>

                    <div className="flex  justify-start gap-2 py-2 items-end border-b border-gray-400">
                        <Button
                            className="px-5 py-1 text-sm font-bold bg-red-100 text-red-700"
                            onClick={this.deleteTransit}
                        >
                            {translate('Delete transit')}
                        </Button>
                        <Button
                            className="px-5 py-1 text-sm font-bold bg-yellow-100 text-yellow-700"
                            onClick={this.reFetchMetocean}
                        >
                            {translate('Update MetOcean data')}
                        </Button>
                        <Button
                            className="px-5 py-1 text-sm font-bold bg-yellow-100 text-yellow-700"
                            onClick={this.reAnalyseTransit}
                        >
                            {translate('Re-analyse transit')}
                        </Button>
                        <Button
                            className="px-5 py-1 text-sm font-bold bg-yellow-100 text-yellow-700"
                            onClick={this.reprocessTransit}
                        >
                            {translate('Reprocess transit')}
                        </Button>
                    </div>
                    <div className="flex justify-end items-center">
                        <div className="mt-5 flex gap-3">
                            <Button
                                onClick={this.handleFormCancel}
                                className="px-4 py-2 font-bold border border-gray-400"
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                onClick={this.handleReset}
                                type="button"
                                className="px-4 py-2 bg-yellow-100 text-yellow-700 rounded-md"
                            >
                                {translate('Reset')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    vesselCategories: state.port.vesselCategories,
    mainControls: state.layout.mainControls,
    port: state.port.port,
    openModelFunction: state.layout.openModelFunction,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTransitModel);
